export enum BronIdOrFlatIds {
  FLAT_IDS = 'flatIds',
  BRON_ID = 'orderId'
}
